"use client";

import { useEffect } from "react";

type VideoModalProps = {
  open: boolean;
  onClose: () => void;
  videoUrl: string;
};

export default function VideoModal({
  open,
  onClose,
  videoUrl,
}: VideoModalProps) {
  useEffect(() => {
    if (!open) return;

    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center">
      {/* BACKDROP */}
      <div className="absolute inset-0 bg-black/80" onClick={onClose} />

      {/* VIDEO */}
      <div className="relative z-10 w-full max-w-5xl aspect-video">
        <iframe
          src={videoUrl}
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 w-full h-full z-0"
        />
      </div>

      {/* CLOSE */}
      <button
        onClick={onClose}
        className="
          absolute top-6 right-6
          text-white text-3xl
          opacity-80 hover:opacity-100
        "
      >
        ×
      </button>
    </div>
  );
}
